export default __webpack_public_path__ + "static/media/logo-environment.6f3f69dd.svg";